import React, { useRef, useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
// import './SearchBar.css';
import "../App.css"
import { useNavigate } from 'react-router-dom';

const SearchBar = ({ onAnalyze }) => {
  const Navigate = useNavigate();
  // Create a reference for the input field
  const searchInputRef = useRef(null);
  

   // Check if the user is on a mobile device
   const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);

   useEffect(() => {
     // Only focus the input field automatically if not on a mobile device
     if (!isMobile && searchInputRef.current) {
       searchInputRef.current.focus();
     }
   }, [isMobile]);


  const [youtubeLink, setYoutubeLink] = useState('');
  const [errorMessage, setErrorMessage] = useState("");


  const extractVideoId = (url) => {
    try {
      const videoRegex =
        /(?:youtube\.com\/(?:.*[?&]v=|embed\/|shorts\/)|youtu\.be\/)([0-9A-Za-z_-]{11})/;
      const match = url.match(videoRegex);
      return match ? match[1] : null;
    } catch (error) {
      console.error("Error extracting video ID:", error);
      return null;
    }
  }; 
  

  
  const handleAnalyzeClick = (e) => {
    e.preventDefault();

    const videoId = extractVideoId(youtubeLink);

    if (!videoId) {
      console.error("Invalid YouTube link");
      setErrorMessage("Invalid YouTube link. Please enter a valid link.");
      return;
    }

    setErrorMessage(""); // Clear any previous error messages
    console.log("Extracted Video ID:", videoId); // Optional: log the video ID for debugging
    onAnalyze(youtubeLink); // Pass the original YouTube link to the analyze function
  };


  return (
    <div className="search-container">
      <div className='login-container'>
        <h1 className="logo-login middle-align" >
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1>
      </div>
      {/* <h1 className=" logo-login " >
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1> */}
      {/* <h1 className="logo" >CommentInsight</h1> */}
      <p className='align-vertical-p'>Turn
      <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z"/></svg>
        Comments into 
        <svg xmlns="http://www.w3.org/2000/svg" height="18.5px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M309-389q29 29 71 29t71-29l160-160q29-29 29-71t-29-71q-29-29-71-29t-71 29q-37-13-73-6t-61 32q-25 25-32 61t6 73q-29 29-29 71t29 71ZM240-80v-172q-57-52-88.5-121.5T120-520q0-150 105-255t255-105q125 0 221.5 73.5T827-615l52 205q5 19-7 34.5T840-360h-80v120q0 33-23.5 56.5T680-160h-80v80h-80v-160h160v-200h108l-38-155q-23-91-98-148t-172-57q-116 0-198 81t-82 197q0 60 24.5 114t69.5 96l26 24v208h-80Zm254-360Z"/></svg>
        Smart Decisions</p>
         <div className="search-bar">
        {/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 18H6c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h1v1c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V4h1c.55 0 1 .45 1 1v14c0 .55-.45 1-1 1z"/></svg> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-youtube search-icon" viewBox="0 0 16 16">
          <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z"/>
        </svg>
        {/* <FaSearch className="search-icon" /> */}
        <input className="searchbar-input"
          type="text"
          placeholder="Paste YouTube Video link"
          value={youtubeLink}
          onChange={(e) => setYoutubeLink(e.target.value)}
          ref={searchInputRef}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleAnalyzeClick(e); // Trigger analyze on Enter key press
            }
          }}
        />
        <button onClick={handleAnalyzeClick} className="analyze-btn">✧ Analyze</button>
      </div>
      
      {/* Display error message if present */}
      {errorMessage && <p className="error-message">{errorMessage}</p>}


      
    </div>
    
  );
};

export default SearchBar;
